import { render, staticRenderFns } from "./TipoVehiculoIndex.vue?vue&type=template&id=5e311463"
import script from "./TipoVehiculoIndex.vue?vue&type=script&lang=js"
export * from "./TipoVehiculoIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports